import { ENUSStrings } from "./en-us";
import { format, ILocalizedStrings } from "./strings";

const STRINGS: ILocalizedStrings = new ENUSStrings();

export {
	STRINGS,
	format
};
